<template>
  <Card :title="$t('claims.serviceUnavailable.title')">
    <template v-slot:content>
      <p
        class="service-unavailable-text"
        v-dompurify-html="$t('claims.serviceUnavailable.text')"
      ></p>
    </template>
    <template v-slot:footer>
      <div class="footer-cta footer-cta-left">
        <CustomButton
          @click="handleBackToOverview"
          button-id="back-to-overview-button"
          :button-color="ButtonColor.LINK"
        >
          {{ $t('claims.serviceUnavailable.backButton') }}
        </CustomButton>
      </div>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { Card, CustomButton, ButtonColor } from 'de-zurich-ui-library'
import { navigate } from '@/utils/NavigationUtils'

const handleBackToOverview = (): void => {
  navigate(globalThis.ENV_CONFIG?.REDIRECTS.LOGIN_PAGE)
}
</script>

<style scoped lang="scss">
.service-unavailable-text {
  line-height: 1.5;
  font-size: 18px;
  color: #23366f;
}

.footer-cta-left {
  gap: 16px;
  flex-wrap: wrap;
  display: flex;
  margin-top: 8px;
}
</style>
